import {ActionList, ActionMenu, FormControl} from '@primer/react'
import {MeterIcon, PlayIcon, SkipIcon, type Icon as IconType} from '@primer/octicons-react'
import {RulesetEnforcement} from '@github-ui/repos-rules-types/rules-types'
import {useEnforcement} from '../contexts/EnforcementContext'

type EnforcementItem = {
  label: string
  value: RulesetEnforcement
  Icon: IconType
  color: string
}

export function EnforcementPicker() {
  const {enforcement, updateEnforcement} = useEnforcement()
  const items: EnforcementItem[] = [
    {
      label: 'Active',
      value: RulesetEnforcement.Enabled,
      Icon: PlayIcon,
      color: 'fgColor-success',
    },
    {
      label: 'Evaluate',
      value: RulesetEnforcement.Evaluate,
      Icon: MeterIcon,
      color: 'fgColor-attention',
    },
    {
      label: 'Disabled',
      value: RulesetEnforcement.Disabled,
      Icon: SkipIcon,
      color: 'fgColor-severe',
    },
  ]

  const {Icon: SelectedIcon, ...selectedItem} = items.find(({value}) => value === enforcement) as EnforcementItem

  return (
    <FormControl>
      <FormControl.Label>Enforcement status</FormControl.Label>
      <ActionMenu>
        <ActionMenu.Button leadingVisual={<SelectedIcon className={selectedItem.color} />}>
          {selectedItem.label}
        </ActionMenu.Button>
        <ActionMenu.Overlay>
          <ActionList selectionVariant="single" role="menu" aria-label="Item">
            {items.map(({label, color, Icon, value}) => (
              <ActionList.Item
                key={label}
                role="menuitemradio"
                selected={value === enforcement}
                aria-checked={value === enforcement}
                onSelect={() => updateEnforcement(value)}
              >
                <ActionList.LeadingVisual>
                  <Icon className={color} />
                </ActionList.LeadingVisual>
                {label}
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </FormControl>
  )
}
